export default __webpack_public_path__ + "static/media/Cancel.7c98e7fe.svg";